import React, { Component, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Grid,
    TextField,
    Button,
    RadioGroup,
    FormControlLabel,
    Radio,
    Checkbox,
} from '@material-ui/core';

import { Translate } from '../../Localization/Translate';
import Api from '../../../nibeApi';

class CoolingAndWarmWater extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentLoaded: false,
            emailCheckValue: '',
            classes: '',
            goNextIsActive: false,
            coolingAndWarmWaterObject: {},
            disableCooling: false,
        };
    }
    componentDidMount() {
        const { coolingAndWarmWaterObject, pumpType } = this.props;
        this.updateInputData('tapWaterKnown', coolingAndWarmWaterObject.tapWaterKnown ?? false);

        if (pumpType === 'hybride') {
            this.updateInputData(undefined, false, undefined, true);
        }
        this.setState({
            componentLoaded: true,
            coolingAndWarmWaterObject,
            disableCooling: pumpType === 'hybride',
            disableQuoteTapWater: pumpType === 'hybride',
        });
    }

    updateInputData(elementName, value, checkInt, isHybride) {
        const scope = this;
        if (checkInt) {
            value = parseInt(value, 10);
            if (Number.isNaN(value)) {
                value = "";
            }
        }
        let coolingAndWarmWaterObject = { ...this.props.coolingAndWarmWaterObject };
        if (coolingAndWarmWaterObject) {
            if (!isHybride) {
                coolingAndWarmWaterObject[elementName] = value;
            }
            const { updateState } = this.props;
            let goNextIsActive = false;
            if (isHybride) {
                coolingAndWarmWaterObject['quoteCooling'] = false;
                coolingAndWarmWaterObject['quoteTapWater'] = false;
            }
            if (coolingAndWarmWaterObject.quoteCooling !== undefined &&
                coolingAndWarmWaterObject.quoteTapWater !== undefined &&
                (coolingAndWarmWaterObject.quoteTapWater === false || coolingAndWarmWaterObject.tapWaterKnown ||
                    (coolingAndWarmWaterObject.quotePersons &&
                        coolingAndWarmWaterObject.quoteTime &&
                        coolingAndWarmWaterObject.showerTypes))) {
                goNextIsActive = true;
                if (coolingAndWarmWaterObject.quoteTapWater === false || coolingAndWarmWaterObject.tapWaterKnown) {
                    if (!coolingAndWarmWaterObject.tapWaterKnown) {
                        coolingAndWarmWaterObject.waterPeak = 0;
                    }
                    if (elementName === 'waterPeak') {
                        coolingAndWarmWaterObject.waterPeak = value;
                    }
                    if (coolingAndWarmWaterObject.quoteTapWater === false) {
                        coolingAndWarmWaterObject.waterPeak = 0;
                    }
                    delete coolingAndWarmWaterObject.quoteBath;
                    delete coolingAndWarmWaterObject.quoteTime;
                    delete coolingAndWarmWaterObject.showerTypes;
                }
                else {
                    let quoteBathCalc = coolingAndWarmWaterObject.quoteBath && coolingAndWarmWaterObject.quoteBath > 0 ? coolingAndWarmWaterObject.quoteBath : 0;
                    // Calculate and set Water peak
                    coolingAndWarmWaterObject.waterPeak = ((coolingAndWarmWaterObject.quotePersons *
                        coolingAndWarmWaterObject.quoteTime *
                        coolingAndWarmWaterObject.showerTypes +
                        quoteBathCalc) * (10 - 40) / (10 - 55)).toFixed(2) || null;
                    if (updateState) {
                        updateState("topAvailableStep", 5);
                    }
                }
            }
            else {
                coolingAndWarmWaterObject.waterPeak = null;
                if (updateState) {
                    updateState("topAvailableStep", 4);
                }
            }
            if (updateState) {
                updateState("coolingAndWarmWaterObject", coolingAndWarmWaterObject);
            }

            this.setState({
                coolingAndWarmWaterObject,
                goNextIsActive
            });
        }
    }

    sendNibeForm = (formName) => {
        const scope = this;
        const { emailCheckValue } = this.state;

        switch (formName) {
            case 'emailCheck':
                // j.raatjes@breman.nl
                Api.makeCall("get", `Contacts/?emailAddress=${encodeURI(emailCheckValue)}&market=${this.props.config}`, {}, false, function (response) {

                    if (response && response.data.contactid) {
                        scope.props.updateState("userExists", true);
                        scope.props.updateSteps(1, 1);
                    }
                }, function (reason) {
                    scope.props.updateState("addNewUser", true);
                });
                break;
            case 'newCustomer':
                // j.raatjes@breman.nl
                Api.makeCall("get", `Contacts/?emailAddress=${encodeURI(emailCheckValue)}&market=${this.props.config}`, {}, false, function (response) {

                    if (response && response.data.contactid) {
                        scope.setState({
                            userExists: true,
                        });
                        this.props.updateSteps(1, 1);
                    }
                }, function (reason) {
                    scope.setState({
                        addNewUser: true,
                    });
                });
                break;
            default:
                break;
        }
    };
    handleBack = () => {
        const { updateState, activeStep } = this.props;
        if (updateState) {
            updateState("activeStep", activeStep - 1);
        }
    };
    render() {
        const classes = makeStyles((theme) => ({
            root: {
                width: '100%',
            },
        }));

        const { updateSteps, coolingAndWarmWaterObject, topAvailableStep } = this.props;
        const { goNextIsActive } = this.state;

        return (
            <div>

                <form className={classes.root} noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                    <Grid container alignItems="flex-start" spacing={2}>
                        <Grid item xs={12} sm={12}>
                            {Translate('QuoteTool/step4/quotecoolinglabel')}
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <RadioGroup
                                aria-label={Translate('QuoteTool/step4/quotecoolinglabel')}
                                name={Translate('QuoteTool/step4/quotecoolinglabel')}
                                className={classes.group}
                                value={coolingAndWarmWaterObject.quoteCooling || false}
                                row={true}
                            >
                                <FormControlLabel
                                    value="true"
                                    control={<Radio color="primary" />}
                                    label={Translate('QuoteTool/general/true')}
                                    labelPlacement="end"
                                    checked={coolingAndWarmWaterObject.quoteCooling}
                                    onChange={() => this.updateInputData('quoteCooling', true)}
                                    disabled={this.state.disableCooling}
                                />
                                <FormControlLabel
                                    value="false"
                                    control={<Radio color="primary" />}
                                    label={Translate('QuoteTool/general/false')}
                                    labelPlacement="end"
                                    checked={coolingAndWarmWaterObject.quoteCooling === false}
                                    onChange={() => this.updateInputData('quoteCooling', false)}
                                    disabled={this.state.disableCooling}
                                />
                            </RadioGroup>
                        </Grid>
                    </Grid>

                    <Grid container alignItems="flex-start" spacing={2}>
                        <Grid item xs={12} sm={12}>
                            {Translate('QuoteTool/step4/quotewaterlabel')}
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <RadioGroup
                                aria-label={Translate('QuoteTool/step4/quotewaterlabel')}
                                name={Translate('QuoteTool/step4/quotewaterlabel')}
                                className={classes.group}
                                value={coolingAndWarmWaterObject.quoteTapWater || false}
                                row={true}
                            >
                                <FormControlLabel
                                    value="true"
                                    control={<Radio color="primary" />}
                                    label={Translate('QuoteTool/general/true')}
                                    labelPlacement="end"
                                    checked={coolingAndWarmWaterObject.quoteTapWater}
                                    onChange={() => this.updateInputData('quoteTapWater', true)}
                                    disabled={this.state.disableQuoteTapWater}
                                />
                                <FormControlLabel
                                    value="false"
                                    control={<Radio color="primary" />}
                                    label={Translate('QuoteTool/general/false')}
                                    labelPlacement="end"
                                    checked={coolingAndWarmWaterObject.quoteTapWater === false}
                                    onChange={() => this.updateInputData('quoteTapWater', false)}
                                    disabled={this.state.disableQuoteTapWater}
                                />
                            </RadioGroup>
                        </Grid>
                    </Grid>

                    {coolingAndWarmWaterObject.quoteTapWater &&
                        <Fragment>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={coolingAndWarmWaterObject.tapWaterKnown}
                                        color='primary'
                                        onChange={() => this.updateInputData('tapWaterKnown', !coolingAndWarmWaterObject.tapWaterKnown)}
                                    />
                                } label={Translate('QuoteTool/step4/knownwaterconsumption')}
                            />
                            {coolingAndWarmWaterObject.tapWaterKnown ?
                                <Grid container alignItems="flex-start" spacing={2}>
                                    <Grid item xs={12} sm={8} md={6}>
                                        <TextField fullWidth variant="outlined" type="number" InputProps={{
                                            inputProps: {
                                                min: 0
                                            }
                                        }} label={Translate('QuoteTool/step4/knownwaterconsumption')} onChange={(event) => this.updateInputData('waterPeak', event.target.value, true)} /><br />
                                    </Grid>
                                </Grid> : <div> <Grid container alignItems="flex-start" spacing={2}>
                                    <Grid item xs={12} sm={12} md={6}>
                                        <TextField fullWidth variant="outlined" label={Translate("QuoteTool/step4/quotepersonslabel")} value={coolingAndWarmWaterObject.quotePersons || ''} onChange={(event) => this.updateInputData('quotePersons', event.target.value, true)} />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6}>
                                        <TextField fullWidth variant="outlined" label={Translate("QuoteTool/step4/quotetimelabel")} value={coolingAndWarmWaterObject.quoteTime || ''} onChange={(event) => this.updateInputData('quoteTime', event.target.value, true)} />
                                    </Grid>
                                </Grid>
                                    <Grid container alignItems="flex-start" spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            {Translate('QuoteTool/step4/quoteshowertypelabel')}
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <RadioGroup
                                                aria-label={Translate('QuoteTool/step4/quotewaterlabel')}
                                                name={Translate('QuoteTool/step4/quotewaterlabel')}
                                                className={classes.group}
                                                row={true}
                                            >
                                                <FormControlLabel
                                                    value="7"
                                                    control={<Radio color="primary" />}
                                                    label={Translate('QuoteTool/step4/quoteshowersustainabletypelabel')}
                                                    labelPlacement="end"
                                                    checked={coolingAndWarmWaterObject.showerTypes === 7}
                                                    onChange={() => this.updateInputData('showerTypes', 7, true)}
                                                />
                                                <FormControlLabel
                                                    value="10"
                                                    control={<Radio color="primary" />}
                                                    label={Translate('QuoteTool/step4/quoteshowerstandardtypelabel')}
                                                    labelPlacement="end"
                                                    checked={coolingAndWarmWaterObject.showerTypes === 10}
                                                    onChange={() => this.updateInputData('showerTypes', 10, true)}
                                                />
                                                <FormControlLabel
                                                    value="12"
                                                    control={<Radio color="primary" />}
                                                    label={Translate('QuoteTool/step4/quoteshowerextratypelabel')}
                                                    labelPlacement="end"
                                                    checked={coolingAndWarmWaterObject.showerTypes === 12}
                                                    onChange={() => this.updateInputData('showerTypes', 12, true)}
                                                />
                                                <FormControlLabel
                                                    value="15"
                                                    control={<Radio color="primary" />}
                                                    label={Translate('QuoteTool/step4/quoteshowerluxurytypelabel')}
                                                    labelPlacement="end"
                                                    checked={coolingAndWarmWaterObject.showerTypes === 15}
                                                    onChange={() => this.updateInputData('showerTypes', 15, true)}
                                                />

                                            </RadioGroup>
                                        </Grid>
                                    </Grid>
                                    <Grid container alignItems="flex-start" spacing={2}>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField fullWidth variant="outlined" label={Translate("QuoteTool/step4/quotebathlabel")} value={coolingAndWarmWaterObject.quoteBath || ''} onChange={(event) => this.updateInputData('quoteBath', event.target.value, true)} />
                                        </Grid>
                                    </Grid>

                                    <Grid container alignItems="flex-start" spacing={2}>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField fullWidth variant="outlined" label={Translate("QuoteTool/step4/waterpeak")} value={coolingAndWarmWaterObject.waterPeak || ''} inputProps={{ disabled: true, }} />
                                        </Grid>
                                    </Grid>
                                </div>
                            }
                        </Fragment>
                    }
                </form>

                <Grid container alignItems="flex-start" spacing={2}>
                    <Grid item xs={12} sm={12} md={6}>
                        {goNextIsActive && (coolingAndWarmWaterObject.waterPeak < this.props.selectedPumpObject.waterFrom || coolingAndWarmWaterObject.waterPeak > this.props.selectedPumpObject.waterTo) ?
                            <p className='nibe__error'>
                                {Translate('QuoteTool/step4/watererror')} {this.props.selectedPumpObject.waterTo}
                            </p>
                            : null}
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleBack}
                            className={classes.button}
                        >
                            {Translate("QuoteTool/general/buttonback")}
                        </Button>&nbsp;

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => updateSteps(4, 4)}
                            className={classes.button}
                            disabled={!goNextIsActive}
                        >
                            {Translate("QuoteTool/general/buttonnext")}
                        </Button>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default CoolingAndWarmWater;